<template>
  <fo-layout>
    <a-spin :spinning="loading">
      <a-row :gutter="30" v-if="userItems.length">
        <a-col :sm="8" v-for="(item, index) in userItems" :key="index">
          <div class="pb-40">
            <card
              :imgurl="item.industry_poster_url"
              :title="item.industry_title_zh"
              :info="item.industry_content"
              @click="$router.push('./industries/' + item.code)">
            </card>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="30" v-else>
        <a-col :sm="8" v-for="(item, index) in 3" :key="index">
          <div class="pb-40">
            <card></card>
          </div>
        </a-col>
      </a-row>
    </a-spin>
  </fo-layout>
</template>

<script>
import card from './comps/cardIndustries.vue'
export default {
  components: {
    card
  },
  data () {
    return {
      loading: false,
      // 行业数组
      userItems: [],
      // 读取行业列表请求参数
      readUserCond: {
        page_num: '1',
        page_size: '10'
      }
    }
  },
  mounted () {
    this.readUsers()
  },
  watch: {
    '$route' (obj) {
      if (obj.params.param) {
        window.scroll(0, 0)
      }
    }
  },
  methods: {
    /*
    * 读取行业列表
    */
    readUsers () {
      this.loading = true
      this.get({
        url: 'industryRead',
        data: this.readUserCond
      }, (r) => {
        this.loading = false
        if (r.code) {
          this.userItems = r.data.items
        } else {
          this.error(r.msg)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Models/industries.vue